import { KpiTiles } from '../charts/KpiTiles.tsx';
import { TimeseriesChart } from '../charts/TimeseriesChart.tsx';
import { TopNChart } from '../charts/TopNChart.tsx';
import { HeatmapChart } from '../charts/HeatmapChart.tsx';
import { GeoChart } from '../charts/GeoChart.tsx';
import { StornoTable } from '../charts/StornoTable.tsx';

function ChartCard({
  title,
  subtitle,
  children,
  className = '',
  action,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className={`card animate-slide-up ${className}`}>
      <div className="card-header">
        <div>
          <h3 className="card-title">{title}</h3>
          {subtitle && <p className="card-subtitle">{subtitle}</p>}
        </div>
        {action}
      </div>
      <div className="card-body">{children}</div>
    </div>
  );
}

/** Sektions-Lineal: Mono-Eyebrow links, Hairline füllt, Hinweis rechts. */
function SectionHeader({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className="section-head">
      <h2 className="section-eyebrow">{title}</h2>
      <div className="section-rule" />
      {hint && <span className="section-hint">{hint}</span>}
    </div>
  );
}

export function Dashboard() {
  return (
    <div className="space-y-7 lg:space-y-9 w-full">
      {/* KPI-Strip */}
      <KpiTiles />

      {/* Sektion 1: Zeitverlauf */}
      <section>
        <SectionHeader
          title="Umsatz-Entwicklung"
          hint="Klick auf einen Punkt setzt das Datum als Filter"
        />
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 lg:gap-6">
          <ChartCard
            title="Umsatz im Zeitverlauf"
            subtitle="Vergleich zum Vorjahr"
            className="xl:col-span-2"
          >
            <TimeseriesChart />
          </ChartCard>
          <ChartCard title="Stoßzeiten" subtitle="Wochentag × Stunde">
            <HeatmapChart />
          </ChartCard>
        </div>
      </section>

      {/* Sektion 2: Rankings — auf 2×2 statt 1×4 für lesbare Balken */}
      <section>
        <SectionHeader
          title="Top 10"
          hint="Klick auf einen Balken filtert das Dashboard"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6">
          <ChartCard title="Filialen" subtitle="Nach Umsatz">
            <TopNChart dimension="store_name" measure="umsatz" limit={10} />
          </ChartCard>
          <ChartCard title="Artikel" subtitle="Nach Umsatz">
            <TopNChart dimension="artikel_bezeichnung" measure="umsatz" limit={10} />
          </ChartCard>
          <ChartCard title="Warengruppen" subtitle="Nach Umsatz">
            <TopNChart dimension="warengruppe_name" measure="umsatz" limit={10} />
          </ChartCard>
          <ChartCard title="Kassierer" subtitle="Nach Umsatz">
            <TopNChart dimension="kassierer_name" measure="umsatz" limit={10} />
          </ChartCard>
        </div>
      </section>

      {/* Sektion 3: Geo + Storno */}
      <section>
        <SectionHeader title="Verteilung & Qualität" />
        <div className="grid grid-cols-1 xl:grid-cols-5 gap-4 lg:gap-6">
          <ChartCard
            title="Geografische Verteilung"
            subtitle="Umsatz nach PLZ-Region"
            className="xl:col-span-2"
          >
            <GeoChart />
          </ChartCard>
          <ChartCard
            title="Storno-Quote"
            subtitle="Top-15 Filialen mit Stornos"
            className="xl:col-span-3"
          >
            <StornoTable groupBy="store" />
          </ChartCard>
        </div>
      </section>
    </div>
  );
}
